<div [ngClass]="styleClass" [ngStyle]="style">
  <ng-content></ng-content>
</div>
